export enum FilterDisplayed {
  All = 'all',
  Covid19 = 'covid19',
  DropOffHours = 'drop_off_hours',
  Age = 'age',
  Budget = 'budget',
  DaysPerWeek = 'days_per_week',
  Subsidy = 'subsidy',
  ToursAndEvents = 'tours_and_events',
  PickUpHours = 'pick_up_hours',
  ProgramOfferings = 'program_offerings',
  ProgramType = 'program_type',
  AvailabilityFilter = 'has_availability',
  NetworkRating = 'network_rating',
  NetworkRatingV2 = 'network_rating_v2',
  SpokenLanguages = 'spoken_languages',
  AgeRange = 'age_range',
}
